export enum SortType {
  Date = 'date',
  Alphabetical = 'alphabetical',
}
